<template>
  <div class="pp-catalog-search">
    <div class="pp-catalog-search__head">
      <h3 class="pp-catalog-search__block-name">Поиск по каталогу</h3>
    </div>

    <div class="pp-catalog-search__body">
      <div class="pp-catalog-search__field-group">
        <div class="pp-catalog-search__cell --search-query">
          <div class="pp-input --large --with-close-button pp-catalog-search__search-input">
            <label for="pp-catalog-search__search-input" class="pp-input__label">Что ищем</label>
            <div class="pp-input__field-box">
              <input v-model="search"
                     type="text" name="pp-catalog-search__search-input" id="pp-catalog-search__search-input"
                     class="pp-input__field --@@size pp-catalog-search__search-input"
                     data-test="test" placeholder="Я хочу найти">
              <button :class="['pp-input__close-btn', search.length > 0 ? '--is-nontransparent':'']"
                      @click="ClearSearch">
                <span class="pp-input__close-btn-part --first"></span>
                <span class="pp-input__close-btn-part --second"></span>
              </button>
            </div>
          </div>
        </div>
        <div class="pp-catalog-search__cell --search-btn">
          <a :href="'/search?search='+search" class="pp-button --transparent-light-without-borders --medium">
            <div class="pp-button__icon-wrapper">
              <svg
                  enable-background="new 0 0 32 32"
                  viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg">
                <path
                    d="m28.7 27.3-8-8c1.6-2 2.5-4.6 2.2-7.3-.5-5.2-4.9-9-9.9-9-.3 0-.7 0-1 0-5.5.6-9.5 5.5-9 11 .5 5.2 4.9 9 9.9 9h1c2-.2 3.9-1 5.4-2.2l8 8zm-14.9-6.3c-.3 0-.5 0-.8 0-4.1 0-7.5-3.1-8-7.2-.4-4.4 2.8-8.3 7.2-8.8h.8c4.1 0 7.5 3.1 8 7.2.4 4.4-2.8 8.3-7.2 8.8z"/>
              </svg>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div :class="['pp-catalog-search__dropdown', have_products ? '--is-visible': '']">
      <div class="pp-catalog-search__results">
        <SearchSuggestion v-for="product in products" :key="product.id" v-bind:product="product"/>
      </div>

      <div class="pp-catalog-search__results-button-wrapper">
        <a :href="'/search?search='+search" class="pp-button --colored-1 --small">
          <div class="pp-button__label">
            На страницу с результатами
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import SearchSuggestion from "./ForGlobalSearch/SearchSuggestion";
import {mapGetters} from 'vuex'

export default {
  name: "GlobalSearch",
  components: {SearchSuggestion},
  data() {
    return {
      search: ""
    }
  },
  beforeMount() {
    let search = window.url_helpers.get_search()
    if (search != null && search.length > 2) {
      this.search = search
    }
  },
  watch: {
    search() {
      if (this.search.length > 2) {
        this.$store.commit('search_products/SET_TEXT', this.search)
      } else if (this.search.length == 0) {
        this.$store.commit('search_products/SET_TEXT', "")
      }
      window.url_helpers.set_search(this.search)
      this.$store.dispatch('search_products/SEARCH')
    },
  },
  methods: {
    ClearSearch() {
      this.search = ""
    }
  },
  computed: {
    ...mapGetters({
      products: 'search_products/GET_PRODUCTS',
      have_products: "search_products/GET_HAVE_PRODUCTS",
    }),
  },
}
</script>

<style scoped>

</style>